import type { Usuario } from './auth'

// Canais de PDV que o usuário pode ver (PDV-Loja='balcao' × PDV-Online='online').
// Feature 09/07 — isolamento por canal. Regra ESPELHADA no backend
// (app/core/security.py, bloco "Canal de PDV atual"):
//   - acesso global (super_admin/admin/gerente) ou permissoes == null → os dois
//   - senão: balcão aparece salvo se permissoes['/pdv'] === false;
//            online é opt-in (permissoes['/pdv-online'] === true).
//   - nenhum dos dois → fallback {balcao} (default legado, nunca vaza online).
// Manter em sincronia com o backend: divergência faria o toggle aparecer/sumir
// de forma inconsistente com o que o servidor realmente permite.
export function canaisPermitidos(user: Usuario | null | undefined): {
  podeBalcao: boolean; podeOnline: boolean
} {
  const isAdmin = user?.perfil === 'super_admin' || user?.nivel === 'admin' || user?.perfil === 'admin'
  const acessoGlobal = isAdmin || user?.nivel === 'gerente'
  const perms = user?.permissoes
  if (acessoGlobal || perms == null) return { podeBalcao: true, podeOnline: true }
  const podeBalcao = perms['/pdv'] !== false
  const podeOnline = perms['/pdv-online'] === true
  if (!podeBalcao && !podeOnline) return { podeBalcao: true, podeOnline: false }
  return { podeBalcao, podeOnline }
}
